__turbopack_context__.v({
  "Embed": "_8UfuHW_Embed",
  "PostPage": "_8UfuHW_PostPage",
  "PostPage-content": "_8UfuHW_PostPage-content",
  "PostPage-hero": "_8UfuHW_PostPage-hero",
  "PostPage-hero-noBG": "_8UfuHW_PostPage-hero-noBG",
  "PostPage-hero-text": "_8UfuHW_PostPage-hero-text",
  "overlay": "_8UfuHW_overlay",
  "separator--promoted": "_8UfuHW_separator--promoted",
  "tagsContainer": "_8UfuHW_tagsContainer",
});
